import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useRemoveMyFood = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [QueryKeys.MY_FOODS_REMOVE],
    mutationFn: (mealId: string) => MealsService.removeMyFoodApiV1MealsMyFoodsMealIdDelete(mealId),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.MY_FOODS] });
    },
  });

  return {
    removeMyFoodAsync: mutation.mutateAsync,
  };
};
